import React from "react";

/**
 * Переиспользуемый Footer компонент
 *
 * @param {Object} props
 * @param {ReactNode} props.children - Содержимое footer
 * @param {string} props.className - Дополнительные CSS классы
 * @param {string} props.variant - Вариант стиля: 'default', 'transparent', 'colored'
 */
const Footer = ({
  children,
  className = "",
  variant = "default",
  ...props
}) => {
  const variants = {
    default: "bg-white border-t border-gray-200",
    transparent: "bg-transparent",
    colored: "bg-[#A1F69E]",
  };

  const footerClasses = `
    flex items-center justify-center
    w-full p-4 mt-auto
    ${variants[variant] || variants.default}
    ${className}
  `
    .trim()
    .replace(/\s+/g, " ");

  return (
    <footer className={footerClasses} {...props}>
      {children}
    </footer>
  );
};

export default Footer;
